var _circle, _path, _circle2, _circle3, _circle4, _circle5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceImgood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    fill: "#AFD15D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8828 113C61.9236 113.165 61.9677 113.333 62.0155 113.505C62.6302 127.112 77.3845 138 95.4956 138C113.607 138 128.361 127.112 128.976 113.505C129.023 113.333 129.068 113.165 129.108 113H128.992C128.989 113.169 128.983 113.337 128.976 113.505C127.14 120.109 119.931 131.952 95.4955 131.952C71.0605 131.952 63.8517 120.109 62.0155 113.505C62.008 113.337 62.0025 113.169 61.9993 113H61.8828Z",
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.8807,
    cy: 78.8807,
    r: 20.8807,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 66.8645,
    cy: 78.8807,
    r: 17.8977,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.119,
    cy: 78.8807,
    r: 20.8807,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 124.136,
    cy: 78.2841,
    r: 17.8977,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceImgood);
export default __webpack_public_path__ + "static/media/Face_Im good.c5794ed3168cfaed1e24b6888c9cb34d.svg";
export { ForwardRef as ReactComponent };